// extracted by mini-css-extract-plugin
export default {"title":"LimitsCellRenderer_title__AgfZ-","titleRow":"LimitsCellRenderer_titleRow__sePEO","limitsReached":"LimitsCellRenderer_limitsReached__4Gb1E"};